export class UserOTP{
    otp!: string;
    phoneNumber!: string;
    npi!: string;
}
export class PatientProfilePictureModel{ 
    patientId!: number; 
    pharmacyNpi!: string; 
    profilePictureId!: string; 
}  
export class PharmacyInfoModel{
    pharmacyNpi!: string;
    patientId!: number;
}
export class PatientLoginStatusModel{
    pharmacyNpi!: string;
    patientId!: number;
    isLoggedIn!: boolean;
}

export class AddToRefillQueueModel{
    pharmacyNpi!: string;
    patientId!: number;
    authorizeToQueue!:[];
}

export class authorizeToQueue{
    PrescrefillId!:string
    PrescNum!:string;
    RefillNum!: string;
    PartialFillNo!:string;
}
export class RxHistoryModel{
    patientId!: number;
    pharmacyNpi!: string;
    fromDate!: string;
    toDate!: string;
    rxStatus!:string
}

export class SubscriptionType{
    pharmacyNpi!: string;
    patientId!: number;
    status!: string;
}

export class UserDetialEmail{ 
    patientEmail!: string;
}

interface MetaData {
    npiData: string | null;
    phoneNumber: string | null;
    patientNo: number | null;
}

interface Result {
    metaData: {
        metaData: MetaData[];
    };
    identifier: string;
    status: number;
}

export class ProfileInfoModel{
    pharmacyNpi!: string;
    patientNo!: number;
    base64Input!: string;
    fileExtensionType!: string
}